import React from 'react';
type RollLinkProps = {
  href: string;
  label: string;
  className?: string;
};
const STAGGER_MS = 32;
const letterTransition = 'transition-transform duration-[750ms] ease-luxe motion-reduce:transition-none';
export function RollLink({
  href,
  label,
  className = ''
}: RollLinkProps) {
  const letters = Array.from(label);
  return <a href={href} aria-label={label} className={`group relative inline-block pb-2.5 ${className}`} data-id="element-1097" data-mp="1ej0uqsp3qoi9">
      <span className="flex" aria-hidden="true" data-id="element-1098" data-mp="zuedglfwzmoe">
        {letters.map((char, i) => {
        const glyph = char === ' ' ? '\u00A0' : char;
        const delay = {
          transitionDelay: `${i * STAGGER_MS}ms`
        };
        return <span key={i} className="relative inline-block overflow-hidden" data-id="element-1099" data-mp="vu3xqh2blhwc" data-mpi={i}>
              <span className={`block group-hover:-translate-y-full group-focus-visible:-translate-y-full ${letterTransition}`} style={delay} data-id="element-1100" data-mp="vrzwk6vt2wzr">
                {glyph}
              </span>
              <span className={`absolute inset-0 block translate-y-full group-hover:translate-y-0 group-focus-visible:translate-y-0 ${letterTransition}`} style={delay} data-id="element-1101" data-mp="1fojc7zkoxpi5">
                {glyph}
              </span>
            </span>;
      })}
      </span>
      <span className="absolute bottom-0 left-0 h-px w-full bg-current opacity-40" aria-hidden="true" data-id="element-1102" data-mp="1knvwqdo3akhk" />
      <span className="absolute bottom-0 left-0 h-px w-full origin-right scale-x-0 bg-current transition-transform duration-[1100ms] ease-silk group-hover:origin-left group-hover:scale-x-100 group-focus-visible:origin-left group-focus-visible:scale-x-100 motion-reduce:transition-none" aria-hidden="true" data-id="element-1103" data-mp="wxrrk1v96cog" />
    </a>;
}